// extracted by mini-css-extract-plugin
module.exports = {"pointerIcon":"PointerIcon_pointerIcon__ZaSRl"};